module.exports = __webpack_public_path__ + "static/media/9.33d4c0a4.jpg";